import { createFileRoute, Link, Outlet, useRouterState, useSearch } from '@tanstack/react-router';

function AdminDripCampaignsLayout() {
  const search = useSearch({ from: '/admin/drip-campaigns' });
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isIndex =
    pathname === '/admin/drip-campaigns' || pathname === '/admin/drip-campaigns/';
  const tab = (suffix: string) => {
    const active =
      (suffix === '' && isIndex) || (suffix !== '' && pathname === `/admin/drip-campaigns/${suffix}`);
    return `px-3 py-2 text-sm border-b-2 -mb-px ${
      active ? 'border-nova-primary text-nova-primary' : 'border-transparent text-nova-muted-foreground hover:text-nova-foreground'
    }`;
  };

  return (
    <div className='space-y-4'>
      <div>
        <h1 className='text-2xl font-semibold text-nova-foreground'>Drip Campaigns</h1>
        <p className='text-sm text-nova-muted-foreground mt-1'>
          Read-only view of email, SMS, and push drip campaigns. Open rate only where Mailgun opens are stored.
        </p>
      </div>
      <nav className='flex flex-wrap gap-2 border-b border-nova-border pb-px'>
        <Link to='/admin/drip-campaigns' search={search} className={tab('')}>
          Overview
        </Link>
        <Link to='/admin/drip-campaigns/activation' search={search} className={tab('activation')}>
          Activation
        </Link>
        <Link to='/admin/drip-campaigns/conversion' search={search} className={tab('conversion')}>
          Conversion
        </Link>
        <Link to='/admin/drip-campaigns/retention' search={search} className={tab('retention')}>
          Retention
        </Link>
        <Link to='/admin/drip-campaigns/growth' search={search} className={tab('growth')}>
          Growth
        </Link>
        <Link to='/admin/drip-campaigns/prospects' search={search} className={tab('prospects')}>
          Prospects
        </Link>
      </nav>
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/admin/drip-campaigns')({
  component: AdminDripCampaignsLayout,
  validateSearch: (search: Record<string, unknown>) => ({
    campaign: typeof search.campaign === 'string' ? search.campaign : undefined,
    range: ['7d', '30d', '90d', 'all'].includes(String(search.range))
      ? (search.range as '7d' | '30d' | '90d' | 'all')
      : '30d',
  }),
});
